var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon07Excelfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C4.44772 3 4 3.44772 4 4V11H3C2.44772 11 2 11.4477 2 12V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V12C22 11.4477 21.5523 11 21 11H20V4C20 3.44772 19.5523 3 19 3H5ZM18 11V5H6V11H9C9.55228 11 10 11.4477 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.4477 14.4477 11 15 11H18ZM4 19V13H8.12602C8.57006 14.7252 10.1362 16 12 16C13.8638 16 15.4299 14.7252 15.874 13H20V19H4Z",
    fill: "#46B476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon07Excelfile);
export default __webpack_public_path__ + "static/media/icon07_excelfile.8cead2c00dc35fb653b27df05b34ad7e.svg";
export { ForwardRef as ReactComponent };